import Component from '../inherited/Component'

export default class ZoomImage extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._zoomEl = document.querySelector('#zoom-image')
    this._zoomImg = document.querySelector('#zoom-image img')
  }
 
  async mount () {
    this._elem.addEventListener('click', () => {
      this._zoomImg.setAttribute('src', this._elem.getAttribute('data-image-zoom-url'))
      this._zoomEl.classList.add('zoomed-img')
    })
    this._zoomEl.addEventListener('click', () => {
        this._zoomEl.classList.remove('zoomed-img')
    })
  }

}